// extracted by mini-css-extract-plugin
module.exports = {"root":"_9ebbc7","readMore":"_a1d995","expanded":"_465472","content":"_4a5d78","showMoreButton":"_60d45c"};